
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyCompanyAssociationCarriers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company1"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"infoDocuments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"docType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"docFileUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"needsSignatureWhenOnboarding"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"company2"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mcNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dotNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fidNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dispatchPhoneNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"afterHoursPhoneNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"faxNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryContactName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryContactPhoneNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accountingEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"officeAddress"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"suite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zipCode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"numOwnerOpDrivers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numCompanyDrivers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"doesTransportTl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"doesTransportLtl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preferredLanes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numTractors"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"num45FlatVans"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"num48FlatVans"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"num53FlatVans"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numReefers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numStepDecks"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"num4Tarps"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"num6Tarps"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"num8Tarps"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numCoilRacks"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numPipeStakes"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"onboardingStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customCarrierName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onboardingDocs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"docType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"docFileUrl"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":993}};
    doc.loc.source = {"body":"query {\n  companyCompanyAssociationCarriers {\n    company1 {\n      id\n      name\n      infoDocuments {\n        id\n        docType\n        docFileUrl\n        needsSignatureWhenOnboarding\n      }\n    }\n    company2 {\n      id\n      name\n      email\n      mcNumber\n      dotNumber\n      fidNumber\n      dispatchPhoneNumber\n      afterHoursPhoneNumber\n      faxNumber\n\n      primaryContactName\n      primaryContactPhoneNumber\n      accountingEmail\n\n      officeAddress {\n        streetAddress\n        suite\n        city\n        state\n        zipCode\n      }\n      numOwnerOpDrivers\n      numCompanyDrivers\n      doesTransportTl\n      doesTransportLtl\n      preferredLanes\n\n      numTractors\n      num45FlatVans\n      num48FlatVans\n      num53FlatVans\n      numReefers\n      numStepDecks\n      num4Tarps\n      num6Tarps\n      num8Tarps\n      numCoilRacks\n      numPipeStakes\n    }\n\n    onboardingStatus\n    customCarrierName\n    onboardingDocs {\n      id\n      docType\n      docFileUrl\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
